import {
    DmsPage, DmsAltBox, intl, DmsTextField, DmsButton, DmsTabber
} from "dmsbasereact"
import { Typography, Box } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { InfoTable } from "../../components/InfoTable/InfoTable";

const SearchResults = ({ title, results }) => {
    return (
        <Box>
            {/* Título */}
            <Typography variant="h6" sx={{ mb: 1 }}>
                {title}
            </Typography>

            {/* Resultados */}
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                {results.map((item, index) => (
                    <Typography
                        key={index}
                        component="li"
                        sx={{ listStyleType: "disc", mb: 0.5, color:"primary.main" }}
                    >
                        {item.name} ({item.role})
                    </Typography>
                ))}
            </Box>
        </Box>
    );
};

export const SearchPage = () => {

    const users = [
        { name: "João Henrique Almeida", role: "Prescritor" },
        { name: "João Vitor Ramos", role: "Dispensador" },
        { name: "João Pedro da Silva", role: "Prescritor" },
    ];
    
    
    const institutions = [
        { name: "Instituto Médico João de Andrade", role: "" },
        { name: "Fundação São João da Saúde", role: "" },
        { name: "Hospital Universitário João Batista", role: "" },
    ]

    const doctorFields = [
        { label: intl.get("FullName").d("Full Name"), value: "João Pedro da Silva" },
        { label: intl.get("CRMNumber").d("CRM Number"), value: "123456" },
        { label: intl.get("CRMState").d("CRM State"), value: "SP" },
        { label: intl.get("Street").d("Street"), value: "Rua das Palmeiras" },
        { label: intl.get("Number").d("Number"), value: "150" },
        { label: intl.get("Complement").d("Complement"), value: "Sala 203" },
        { label: intl.get("Neighborhood").d("Neighborhood"), value: "Centro" },
        { label: intl.get("City").d("City"), value: "São Paulo" },
        { label: intl.get("State").d("State"), value: "SP" },
        { label: intl.get("ZipCode").d("Zip Code"), value: "01000-000" },
        { label: intl.get("Phone").d("Phone"), value: "(11) 3333-4455" },
        { label: intl.get("Email").d("Email"), value: "joao.silva@exemplo.com" },
        { label: intl.get("Mobile").d("Mobile"), value: "(11) 98888-7766" },
        { label: intl.get("CreatedAt").d("Created At"), value: "10/06/2025" },
        { label: intl.get("Status").d("Status"), value: "Bloqueado" },
    ];

    const tabs = [
        {
            title: intl.get("SearchResults").d("Search Results"),
            component: (
                <Box>
                    <SearchResults title={intl.get("Search.FoundUsers").d("Found Users:")} results={users} />
                    <SearchResults title={intl.get("Search.FoundInstitutions").d("Found Institutions")} results={institutions} />

                </Box>
            )

        },
        {
            title: intl.get("UserX").d("User: João Henrique Almeida"),
            component: (
                <Box sx={{width:'50%'}}>
                    <InfoTable title={intl.get("Info").d("Info")} fields={doctorFields} />
                </Box>
            )
        }
    ]

    return (
        <DmsPage name='Search'>
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("Search").d("Search")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={2}
                    // sx={{ height: '100vh' }}
                    >
                        <Box>
                            <DmsTextField
                                name="search"
                                label={intl.get("Search.Label").d("Search")}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                fullWidth
                            />

                            <DmsButton
                                text={intl.get("Search").d("Search")}
                                variant="success"
                                style={{ marginTop: '8px' }}
                            />
                        </Box>
                        <DmsTabber tabs={tabs} pageName={intl.get("Search").d("Search")} sxContent={{paddingTop: 0, p: 2}} />
                    </Box>
                </DmsAltBox.Body>
            </DmsAltBox.Card>

        </DmsPage>
    )
}